import { Constants } from "@/utils/constants"
import { UnitsActiveData } from "../../../../service/dashboard/response"
import { buildUTCOffsetDateRange, parseTimeToTimeZone } from "../../../../utils/methods/calcDate"
import { FilterData } from "./typing/interfaces"
import { TableData } from "./typing/type"

const UnitDataFilters = (payload?: TableData) => {
    let filters = []

    if (!!payload?.month?.length) {
        filters.push({ terms: { mes: payload?.month } })
    }
    if (!!payload?.years?.length) {
        filters.push({ terms: { ano: payload?.years } })
    }
    if (!!payload?.unit?.length) {
        filters.push({ terms: { unidad_id: payload?.unit } })
    }
    if (!!payload?.zone?.length) {
        filters.push({ terms: { zona_id: payload?.zone } })
    }
    if (!!payload?.division?.length) {
        filters.push({ terms: { division_id: payload?.division } })
    }
    if (!!payload?.role?.length) {
        filters.push({ terms: { rol_id: payload?.role } })
    }
    if (!!payload?.userType?.length) {
        filters.push({ terms: { tipo_usuario_id: payload?.userType } })
    }
    if (!!payload?.curp?.length) {
        filters.push({ terms: { curp: payload?.curp } })
    }

    if (!!payload?.user_id?.length) {
        filters.push({ terms: { usuario_id: payload.user_id } })
    }

    if (!!payload?.questionnaire?.length) {
        filters.push({ terms: { cuestionario_id: payload?.questionnaire } })
    }
    if (!!payload?.questionnaireStatus?.length) {
        filters.push({ terms: { questionario_estatus_id: payload?.questionnaireStatus } })
    }
    if (!!payload?.area?.length) {
        filters.push({ terms: { area_id: payload?.area } })
    }
    if (!!payload?.department?.length) {
        filters.push({ terms: { departamento_id: payload?.department } })
    }
    if (!!payload?.percentage?.length) {
        filters.push({
            range: {
                resultado: {
                    gte: payload?.percentage[0],
                    lte: payload?.percentage[1],
                },
            },
        })
    }

    if (!!payload?.to && !!payload?.from) {
        filters.push({
            bool: {
                should: [
                    {
                        range: {
                            fecha_inicio_full: {
                                gte: payload?.from,
                                lte: payload?.to,
                            },
                        },
                    },
                    {
                        bool: {
                            must_not: {
                                exists: {
                                    field: 'fecha_inicio_full',
                                },
                            },
                        },
                    },
                ],
                minimum_should_match: 1
            },
        })
    }

    return { filters }
}

const formatResponsUnitData = (response: UnitsActiveData) => {
    const hits =
        response?.hits?.hits?.map((item) => {
            const source = item?._source
            const timezone = source.zona_horaria ?? Constants.defaultTimeZone
            const { date: startDate, hour: startHour } = parseTimeToTimeZone(source?.fecha_inicio_respuesta, source?.hora_inicio_respuesta, timezone)
            const { date: endDate, hour: endHour } = parseTimeToTimeZone(source?.fecha_fin_respuesta, source?.hora_fin_respuesta, timezone)

            return {
                id: item?._id,
                year: source?.ano,
                month: source?.mes,
                week: source?.semana,
                unitId: source?.unidad_id,
                unit: source?.unidad,
                country: source?.pais,
                state: source?.estado,
                city: source?.ciudad,
                city_id: source?.ciudad_id,
                zone_id: source?.zona_id,
                zone: source?.zona,
                class: source?.clase,
                division: source?.division,
                division_id: source?.division_id,
                cve: source?.cve,
                role: source?.rol,
                role_id: source?.rol_id,
                userType: source?.tipo_usuario,
                user_type_id: source?.tipo_usuario_id,
                curp: source?.curp,
                user: source?.usuario,
                user_id: source?.usuario_id,
                questionnaire: source?.cuestionario,
                qestionnaire_id: source?.cuestionario_id,
                questionnaire_status: source?.questionario_estatus,
                questionnaire_status_id: source?.questionario_estatus_id,
                area: source?.area,
                area_id: source?.area_id,
                department: source?.departamento,
                department_id: source?.departamento_id,
                start_date: startDate,
                start_hour: startHour,
                end_date: endDate,
                end_hour: endHour,
                application_time: source?.tiempo_aplicacion,
                result: source?.resultado,
            }
        }) ?? []

    return { hits, }
}

const formatDataFiltered = ({ filterData }: { filterData: FilterData }) => {
    const {
        unit,
        role,
        division,
        user,
        userType,
        questionnaire,
        month,
        createYear,
        area,
        department,
        zone,
        child,
        from,
        to,
        questionnaireStatus,
        percentage
    } = filterData
    const units = unit?.map((item) => item.value)
    const roles = role?.map((item) => item.value)
    const divisions = division?.map((item) => item.value)
    const users = user?.map((item) => item.value)
    const userTypes = userType?.map((item) => item.value)
    const questionnaires = questionnaire?.map((item) => item.value)
    const questionnaireStatusIds = questionnaireStatus?.map((item) => item.value)
    const months = month?.map((item) => item.label)
    const years = createYear?.map((item) => item.value)
    const areas = area?.map((item) => item.value)
    const departments = department?.map((item) => item.value)
    const zones = [
        ...(zone?.map((item) => item.value) ?? []),
        ...(child?.map((item) => item.value) ?? []),
    ]
    let end, start

    if (!!to || !!from) {
        const { gte, lte } = buildUTCOffsetDateRange({ from, to })
        end = lte
        start = gte
    }

    return {
        data: {
            from: start,
            to: end,
            area: areas,
            user: users,
            user_id: users,
            department: departments,
            division: divisions,
            questionnaire: questionnaires,
            questionnaireStatus: questionnaireStatusIds,
            role: roles,
            unit: units,
            userType: userTypes,
            zone: zones,
            month: months,
            years,
            percentage
        }
    }
}

export { formatDataFiltered, formatResponsUnitData, UnitDataFilters }

